
import LotteryIcon from'../../../../assets/SubscriptionImage/Lottery.png';
import PayrollIcon from '../../../../assets/SubscriptionImage/Payroll.png';
import TimeCardIcon from '../../../../assets/SubscriptionImage/TimeCard.png';
import GasIcon from '../../../../assets/SubscriptionImage/Gas.png';
import ExpenseIcon from '../../../../assets/SubscriptionImage/expense.png';
import SaleIcon from '../../../../assets/SubscriptionImage/Sale.png';
import InventoryIcon from'../../../../assets/SubscriptionImage/Inventory.png';
import ChequeIcon from '../../../../assets/SubscriptionImage/Cheque.png';
import PosIcon from '../../../../assets/SubscriptionImage/Pos.png';
import GeneralIcon from '../../../../assets/SubscriptionImage/General.png';
import CameraApp from '../../../../assets/SubscriptionImage/CameraIcon.jpg';
import LegalLogo from '../../../../assets/SubscriptionImage/LegalApp.png'
import EcommerceLogo from '../../../../assets/SubscriptionImage/e-com.png'
import AssetsLogo from '../../../../assets/img/logo-image/assets.png'
import config from '../../../../config/Global.json';

export const resolveModuleIcon = (icon) => {
  if (!icon) return null;
  if (/^(https?:|data:|blob:)/i.test(icon)) return icon;
  return `${config.api.host.replace(/\/$/, '')}/${String(icon).replace(/^\//, '')}`;
};

export const handleModuleIconError = (event, fallback) => {
  const image = event.currentTarget;
  if (image.dataset.fallbackApplied === 'true') return;
  image.dataset.fallbackApplied = 'true';
  image.src = fallback;
};
export const getModuleIcon = (moduleName) => {
  switch (moduleName) {
    case 'Lottery':
      return LotteryIcon;
    case 'Timecard + Payroll':
      return PayrollIcon;
    case 'Gas':
      return GasIcon;
    case 'Spends Tracking':
      return ExpenseIcon;
    case 'Sales + Inventory':
      return InventoryIcon;
    case 'Cheque':
      return ChequeIcon;
    case 'Pos':
    case 'POS':
      return PosIcon;
    case 'General Ledger':
      return GeneralIcon;
      case 'Ecommerce':
      return EcommerceLogo;
      case 'Legal Manage':
      case 'Legal':
      return LegalLogo;
      case 'Asset Management':
      return AssetsLogo;
      case 'Monitoring':
        return CameraApp
    default:
      return ChequeIcon;
  }
};

export const renderModuleIcon = (moduleName, configuredIcon) => {
  if (moduleName === 'Sales + Inventory') {
    return (
      <div style={{
        position: 'relative',
        width: '32px',
        height: '32px',
        marginRight: '8px'
      }}>
        <img 
          src={SaleIcon} 
          alt="Sales" 
          style={{
            position: 'absolute',
            top: -5,
            left: 0,
            width: '24px',
            height: '24px',
          }} 
        />
        <img
          src={InventoryIcon} 
          alt="Inventory"
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: '24px',
            height: '24px',
            zIndex: 1,
          }} 
        />
      </div>
    );
  }

  if (moduleName === 'Timecard + Payroll') {
    return (
      <div style={{
        position: 'relative',
        width: '32px',
        height: '32px',
        marginRight: '8px'
      }}>
        <img 
          src={TimeCardIcon} 
          alt="TimeCard" 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '24px',
            height: '24px',
            zIndex: 1
          }} 
        />
        <img 
          src={PayrollIcon} 
          alt="Payroll" 
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            left: 16,
            width: '24px',
            height: '24px'
          }} 
        />
      </div>
    );
  }

  const fallback = getModuleIcon(moduleName);
  const iconSrc = resolveModuleIcon(configuredIcon) || fallback;
  return <img src={iconSrc} alt={moduleName} onError={(event) => handleModuleIconError(event, fallback)} style={{ width: '32px', height: '32px', objectFit: 'contain'}} />;
};
